import { render } from "./DataFooterWaiter.vue?vue&type=template&id=308e88d5&scoped=true"
import script from "./DataFooterWaiter.vue?vue&type=script&lang=js"
export * from "./DataFooterWaiter.vue?vue&type=script&lang=js"

import "./DataFooterWaiter.vue?vue&type=style&index=0&id=308e88d5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308e88d5"]])

export default __exports__